import React from 'react';
import { Col, Row } from 'antd';
import bigLogo from '../../../../../../assets/img/big-logo.png';
import smallLogo from '../../../../../../assets/img/small-logo.png';
// import { countryCodesMap } from '../../../../../../shared/data/countryCodesMap';

export default function DetailsCompanyInfoFields({ data, flag, generalData }) {
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Company name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.company_info?.[flag]?.company_name ||
                                '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Service name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.company_info?.[flag]?.service_name ||
                                '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Title Service name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.company_info?.[flag]
                                ?.title_service_name ||
                                generalData?.company_info?.[flag]
                                    ?.service_name ||
                                '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Full company name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.company_info?.[flag]
                                ?.company_full_name || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Logos
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div style={{ display: 'flex' }}>
                                <div className="details-table__logo-wrapper">
                                    <img
                                        className="details-table__logo"
                                        src={
                                            generalData?.[`logo_url_${flag}`] ||
                                            bigLogo
                                        }
                                        alt="Big logo"
                                        width={64}
                                        height={64}
                                    />
                                    {generalData?.logos_sizes?.web_app?.logo?.[
                                        flag
                                    ]?.width &&
                                        generalData?.logos_sizes?.web_app
                                            ?.logo?.[flag]?.height && (
                                            <div>
                                                <span>
                                                    {generalData?.logos_sizes
                                                        ?.web_app?.logo?.[flag]
                                                        ?.width || 0}
                                                </span>
                                                <span>&nbsp;x&nbsp;</span>
                                                <span>
                                                    {generalData?.logos_sizes
                                                        ?.web_app?.logo?.[flag]
                                                        ?.height || 0}
                                                </span>
                                            </div>
                                        )}
                                </div>
                                <div className="details-table__logo-wrapper">
                                    <img
                                        className="details-table__logo"
                                        src={
                                            generalData?.[
                                                `logo_email_url_${flag}`
                                            ] || bigLogo
                                        }
                                        alt="Email Logo"
                                        width={64}
                                        height={64}
                                    />
                                </div>
                                <div className="details-table__logo-wrapper">
                                    <img
                                        className="details-table__logo"
                                        src={
                                            generalData?.[
                                                `logo_thumb_url_${flag}`
                                            ] || smallLogo
                                        }
                                        alt="Small logo"
                                        width={32}
                                        height={32}
                                    />
                                </div>
                                <div className="details-table__logo-wrapper">
                                    <img
                                        className="details-table__logo"
                                        src={
                                            generalData?.[
                                                `favicon_url_${flag}`
                                            ] || smallLogo
                                        }
                                        alt="Favicon"
                                        width={32}
                                        height={32}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
